import { lazy, Suspense } from "react";
import { BrowserRouter, HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { MainLayout } from "./layouts/MainLayout";
import { ResumenTab } from "./pages/ResumenTab";
import "./App.css";

const Roadmap = lazy(() => import("./views/Roadmap").then(m => ({ default: m.Roadmap })));
const AsignaturasTab = lazy(() => import("./pages/AsignaturasTab").then(m => ({ default: m.AsignaturasTab })));
const HorariosView = lazy(() => import("./views/HorariosView").then(m => ({ default: m.HorariosView })));
const Notes = lazy(() => import("./views/Notes").then(m => ({ default: m.Notes })));
const ConfigTab = lazy(() => import("./pages/ConfigTab").then(m => ({ default: m.ConfigTab })));

function PageFallback() {
  return (
    <div className="w-full h-full p-6 animate-pulse space-y-4">
      <div className="h-8 w-48 bg-slate-200 rounded-lg" />
      <div className="h-64 w-full bg-slate-100 rounded-2xl border border-slate-200/60" />
    </div>
  );
}

function App() {
  const isWeb = typeof window !== 'undefined' && (
    window.location.hostname.includes('pages.dev') ||
    window.location.hostname.includes('facultad-track')
  );
  const Router = isWeb ? BrowserRouter : HashRouter;

  return (
    <Router>
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<ResumenTab />} />
            <Route path="dashboard" element={<Navigate to="/" replace />} />
            <Route path="roadmap" element={<Roadmap />} />
            <Route path="asignaturas" element={<AsignaturasTab />} />
            <Route path="horarios" element={<HorariosView />} />
            <Route path="notas" element={<Notes />} />
            <Route path="config" element={<ConfigTab />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
